<div class="dialogue-content">
  <div class="mat-dialogue-header border-0">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{LabelConstants.Logout}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal(false)"></button>
  </div>
  <mat-dialog-content>
    <div class="d-flex align-items-center justify-content-center gap-2 flex-column">
      <img src="../../../assets/img/login-logo.svg" alt="" class="logo" />
      <p class="title_approve" *ngIf="reportType == getReportStatusType.APPROVE">{{LabelConstants.ApporovedStatus}} </p>
      <p class="title_reject" *ngIf="reportType == getReportStatusType.REJECT">{{LabelConstants.RejectedStatus}} </p>
      <img *ngIf="imageSrc" [src]="imageSrc" alt="" class="profile-pic-delete" />
      <p class="name">{{name}}</p>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
    <button class="btn btn-primary-outline" (click)="closeModal(true)" >{{LabelConstants.Okay}}</button>
  </div>
</div>